/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import React from 'react';

import { IPatternFieldsProps, PatternTypes } from '../../AllSchedules.Model';

import DaySelectionGrid from '../DaySelectionGrid';
import { MonthField } from './MonthField';
import { WeekField } from './WeekField';
import { DayField } from './DayField';

export const PatternFields = ({ patternType, selectProps, createSchedule, ...props }: IPatternFieldsProps) => {
  switch (patternType) {
    case PatternTypes.Monthly:
      return (
        <>
          <MonthField {...props} selectProps={selectProps?.month} createSchedule={createSchedule} />
          <WeekField {...props} patternType={patternType} selectProps={selectProps?.week} />
          <DayField {...props} selectProps={selectProps?.day} />
        </>
      );
    case PatternTypes.Weekly:
      return (
        <>
          <WeekField {...props} patternType={patternType} selectProps={selectProps?.week} />
          <DayField {...props} selectProps={selectProps?.day} />
        </>
      );
    case PatternTypes.SpecificDay:
      return (
        <>
          <MonthField {...props} selectProps={selectProps?.month} createSchedule={createSchedule} />
          <DaySelectionGrid
            control={props.control}
            name={props.quarterName === 'all' ? 'day' : `quarters.${props.quarterName}.day`}
          />
        </>
      );
    default:
      return null;
  }
};
